/* ==========================================================================
   Ryse - Theoric: a folha do menu do celular

   Quatro coisas que CSS sozinho nao resolve. O visual esta em
   assets/theoric-menu-mobile.css - aqui so vive o que precisa de MEDIDA.

   1) ONDE ELA PARA DE CRESCER (--tm-topo)
      A folha cresce para cima. No celular o cabecalho NAO e sticky: ele rola com
      a pagina. Logo, "a linha da pilula" nao e um numero - depende de quanto a
      pagina rolou quando a pessoa tocou no hamburguer. Chumbar 122px funcionaria
      no topo da home e erraria em qualquer outro lugar (medi: com a pagina
      rolada, o mesmo calculo devolveu 692px).

   2) ARRASTAR PARA BAIXO PARA FECHAR
      A alca e um ::before - pseudo-elemento nao recebe evento. Quem recebe e o
      cartao.

      >>> A ZONA DE ARRASTE E UM ELEMENTO, NAO UMA MEDIDA. <<<
      Romulo, 12/07/2026: "a area de clique dessa barra do topo esta gigante, eu
      tento clicar na primeira opcao e a barra se mexe".
      Ele estava certo, e o erro tem numero: eu tinha escrito uma faixa fixa de
      56px a partir do topo do cartao. Medido, a partir do topo do cartao:

        alca ............... 12 .. 16
        cabecalho .......... 16 .. 22
        PRIMEIRA OPCAO ..... 34 .. 74     <- comeca aos 34

      A faixa de 56px cobria 22 dos 40px do primeiro item. Cada toque em "Celebre"
      era, para o codigo, o comeco de um arraste.

      Numero em pixel nao sabe o que existe embaixo dele. Agora o arraste so
      comeca se o dedo tocar a ALCA (o proprio cartao) ou a barra do topo - e
      nunca num botao ou link dentro dela (o "voltar" do submenu). Se um dia o
      cabecalho mudar de altura, isso continua correto sozinho.

   3) A ALTURA QUE NAO PULA (--tm-altura)
      Ao abrir um submenu o cartao pulava de 452px para 566px de um quadro para o
      outro. height: auto nao transiciona: o navegador nao anima para um valor que
      so descobre depois do layout. Entao a gente da os dois numeros a ele.

      >>> E O NUMERO CERTO SO EXISTE DEPOIS DA FOTO CARREGAR. <<<
      Na primeira versao eu media a altura nova no instante em que o tema trocava
      de tela - e media 367px, quando a verdade era 582px. A diferenca era o banner
      da colecao: uma <img> que ainda nao tinha carregado e por isso nao ocupava
      nada. Medir cedo demais e medir outra pagina.
      Por isso a altura e RE-SINCRONIZADA algumas vezes depois da troca (e no load
      de cada imagem). Como cada sincronizacao passa pela transicao do CSS, uma
      foto que chega atrasada faz a folha CRESCER suave, em vez de dar um tranco.

   4) FECHAR CLICANDO FORA
      A folha deixa a loja aparecer atras - e todo painel que mostra o que esta
      atras cria a expectativa de fechar quando se toca la.

   >>> POR QUE SEMPRE O BOTAO DE FECHAR DO TEMA, E NUNCA classList.remove <<<
   Fechar nao e so tirar a classe .open: o tema tambem destrava o scroll do body e
   reseta o submenu. Clicar no X (escondido, mas vivo) faz tudo isso de graca e
   sobrevive a uma atualizacao do tema.

   Carregado por snippets/theoric-cart-motion-load.liquid.
   ========================================================================== */
(function () {
  var LIMITE_MOBILE = 989;
  var PUXAO_QUE_FECHA = 90;       /* px para baixo que decidem fechar */
  var VELOCIDADE_QUE_FECHA = 0.5; /* px/ms - um peteleco rapido fecha mesmo curto */
  var RE_MEDIDAS = [120, 320, 700]; /* ms - o banner do submenu chega atrasado */

  var secao = document.getElementById('SidePopupMenu');
  if (!secao) return;

  var cartao = secao.querySelector('.mobile-megamenu__card');
  var cabecalho = document.querySelector('.section-header header.header');
  if (!cartao) return;

  var noCelular = function () { return window.innerWidth <= LIMITE_MOBILE; };
  var aberto = function () { return secao.classList.contains('open'); };

  /* ---------------------------------------------------------------- 1. teto */
  function ancorar() {
    var topo = 122; /* rede de seguranca, igual ao fallback do CSS */

    if (cabecalho) {
      var r = cabecalho.getBoundingClientRect();
      var estilo = getComputedStyle(cabecalho);
      var pilula = getComputedStyle(cabecalho, '::before');

      var alturaPilula = parseFloat(pilula.height) || r.height;
      var fundo = r.top + (parseFloat(estilo.paddingTop) || 0) + alturaPilula;

      /* se a pagina rolou e a pilula ja saiu da tela, nao ha em que se ancorar:
         a folha pode usar a tela toda menos uma margem. */
      topo = fundo > 0 ? Math.round(fundo) + 16 : 16;
    }

    document.documentElement.style.setProperty('--tm-topo', topo + 'px');
  }

  /* ------------------------------------------------- 3. altura que nao pula */
  var alturaAtual = 0;

  function teto() {
    var t = parseFloat(getComputedStyle(cartao).maxHeight);
    return isFinite(t) ? t : Infinity;
  }

  /* a altura que o cartao TERIA se ninguem mandasse nele. Trocar a variavel para
     auto, ler e devolver acontece tudo dentro do mesmo quadro - nao chega a
     pintar, entao ninguem ve. */
  function medirNatural() {
    var fixada = cartao.style.getPropertyValue('--tm-altura');
    cartao.style.setProperty('--tm-altura', 'auto');
    var natural = cartao.getBoundingClientRect().height;

    if (fixada) cartao.style.setProperty('--tm-altura', fixada);
    else cartao.style.removeProperty('--tm-altura');

    return natural;
  }

  function sincronizarAltura() {
    if (!noCelular() || !aberto()) return;
    if (cartao.classList.contains('esta-arrastando')) return;

    var nova = Math.min(medirNatural(), teto());
    if (!nova) return;
    if (Math.abs(nova - alturaAtual) < 2) return;   /* nada mudou de verdade */

    /* se a altura ainda esta solta (auto), fixa a atual primeiro: uma transicao
       precisa de um PONTO DE PARTIDA, e `auto` nao e um numero. */
    if (!cartao.style.getPropertyValue('--tm-altura')) {
      cartao.style.setProperty('--tm-altura', (alturaAtual || nova) + 'px');
      void cartao.offsetHeight;   /* forca o navegador a assumir o ponto de partida */
    }

    alturaAtual = nova;

    requestAnimationFrame(function () {
      cartao.style.setProperty('--tm-altura', nova + 'px');
    });
  }

  function sincronizarComAtraso() {
    sincronizarAltura();
    RE_MEDIDAS.forEach(function (ms) { setTimeout(sincronizarAltura, ms); });
  }

  /* o tema troca de tela colocando .is-active no submenu - e o unico aviso dele */
  var observadorTelas = new MutationObserver(sincronizarComAtraso);
  Array.prototype.forEach.call(
    secao.querySelectorAll('.mobile-megamenu__state'),
    function (tela) {
      observadorTelas.observe(tela, { attributes: true, attributeFilter: ['class'] });
    }
  );

  /* uma foto que chega depois muda a altura certa - e ai a folha cresce na curva,
     em vez de dar um tranco. */
  secao.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') sincronizarAltura();
  }, true);

  /* -------------------------------------------------------------- abre/fecha */
  new MutationObserver(function () {
    if (aberto()) {
      ancorar();
      cartao.style.removeProperty('--tm-altura');
      alturaAtual = 0;
      /* espera a folha subir para medir - antes disso ela ainda esta la embaixo */
      setTimeout(function () { alturaAtual = cartao.getBoundingClientRect().height; }, 450);
    } else {
      cartao.style.removeProperty('--tm-altura');
      alturaAtual = 0;
    }
  }).observe(secao, { attributes: true, attributeFilter: ['class'] });

  window.addEventListener('resize', function () {
    if (!aberto()) return;
    ancorar();
    cartao.style.removeProperty('--tm-altura');
    alturaAtual = cartao.getBoundingClientRect().height;
  });

  ancorar();

  function fechar() {
    var x = secao.querySelector('.mobile-megamenu__close');
    if (x) x.click();
  }

  /* ------------------------------------------------------- 4. clicar fora */
  secao.addEventListener('click', function (evento) {
    if (!noCelular()) return;
    if (cartao.contains(evento.target)) return;
    fechar();
  });

  /* --------------------------------------------------------- 2. o arraste */
  var arrastando = false;
  var yInicial = 0;
  var tInicial = 0;
  var dy = 0;

  /* A zona de arraste (leia o item 2 do cabecalho).
     - o proprio cartao: e o que o dedo toca quando toca a ALCA, porque a alca e
       um ::before e nao existe para os eventos;
     - a barra do topo (cabecalho do menu ou a do submenu);
     - NUNCA um botao ou link dentro dela - senao o "voltar" do submenu vira
       arraste e nao volta nada. */
  function naZonaDeArraste(alvo) {
    if (!(alvo instanceof Element)) return false;
    if (alvo.closest('button, a, input, select')) return false;
    if (alvo === cartao) return true;
    return !!alvo.closest('.mobile-megamenu__header, .mobile-megamenu__breadcrumb-bar');
  }

  cartao.addEventListener('pointerdown', function (e) {
    if (!noCelular() || !aberto()) return;
    if (!naZonaDeArraste(e.target)) return;

    arrastando = true;
    yInicial = e.clientY;
    tInicial = e.timeStamp;
    dy = 0;

    cartao.classList.add('esta-arrastando');
    try { cartao.setPointerCapture(e.pointerId); } catch (erro) { /* sem captura, tudo bem */ }
  });

  cartao.addEventListener('pointermove', function (e) {
    if (!arrastando) return;

    dy = e.clientY - yInicial;

    /* para cima nao ha para onde ir: a folha ja esta no lugar dela. Em vez de
       travar seco (que parece bug), ela cede 1/4 do movimento - o elastico que
       todo mundo ja conhece de app nativo. */
    var desloca = dy > 0 ? dy : dy / 4;
    cartao.style.transform = 'translateY(' + desloca + 'px)';
  });

  function largar(e) {
    if (!arrastando) return;
    arrastando = false;

    cartao.classList.remove('esta-arrastando');

    var tempo = Math.max(1, e.timeStamp - tInicial);
    var velocidade = dy / tempo;

    var vaiFechar = dy > PUXAO_QUE_FECHA ||
                    (dy > 20 && velocidade > VELOCIDADE_QUE_FECHA);

    if (vaiFechar) {
      /* termina o movimento que o dedo comecou, DEPOIS avisa o tema. Se fechasse
         agora, o transform inline sumiria e a folha daria um salto de volta para
         translateY(0) antes de descer - um piscao bem no fim do gesto. */
      cartao.style.transform = 'translateY(110%)';
      cartao.style.opacity = '0';

      setTimeout(function () {
        fechar();
        cartao.style.transform = '';
        cartao.style.opacity = '';
      }, 260);

      return;
    }

    cartao.style.transform = '';   /* volta ao lugar, na curva do CSS */
  }

  cartao.addEventListener('pointerup', largar);
  cartao.addEventListener('pointercancel', largar);
})();
